import React from 'react';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import LocalizedLink from '@src/components/LocalizedLink';
import useTranslations from '@src/components/useTranslations';

const PaginationRoot = styled('ul')({
  alignItems: 'center',
  display: 'flex',
  margin: 0,
  padding: 0,
  width: '100%',
});
const PaginationLink = styled('li')({
  flexBasis: '25%',
});
const PaginationPrevious = styled(PaginationLink)({});
const PaginationNext = styled(PaginationLink)({ textAlign: 'right' });
const PaginationText = styled(Typography)({
  flexGrow: 1,
  textAlign: 'center',
});

interface PaginationProps {
  isFirst: boolean;
  isLast: boolean;
  currentPage: number;
  numPages: number;
  prevPage?: string;
  nextPage?: string;
}

export default function Pagination({
  isFirst,
  isLast,
  currentPage,
  numPages,
  prevPage,
  nextPage,
}: PaginationProps) {
  const { next, prev, of } = useTranslations();

  return (
    <PaginationRoot>
      <PaginationPrevious>
        {!isFirst && (
          <Button component={LocalizedLink} to={prevPage}>
            ← {prev}
          </Button>
        )}
      </PaginationPrevious>
      <PaginationText color="textSecondary" variant="body2">
        {currentPage} {of} {numPages}
      </PaginationText>
      <PaginationNext>
        {!isLast && (
          <Button component={LocalizedLink} to={nextPage}>
            {next} →
          </Button>
        )}
      </PaginationNext>
    </PaginationRoot>
  );
}
